<canvas ref="board" id="game-canvas" width="1600" height="400"></canvas>